import { User, Membership } from '@/types/user.type';

export type UserOrgInfo = {
  userId: string | null;
  platformRole?: string | null;
};

const EXCLUDED_ORG_IDS = ['default', import.meta.env.VITE_SYSTEM_ADMIN_ORG_ID].filter(Boolean);
const SYSTEM_ADMIN_ORG_ID = import.meta.env.VITE_SYSTEM_ADMIN_ORG_ID;

function isSystemRole(role: string): boolean {
  return role.startsWith('sys');
}

export function getUserOrgs(user: User | null): Membership[] {
  if (!user) return [];
  return (user.memberships || []).filter(
    (m) => !EXCLUDED_ORG_IDS.includes(m.organizationId) && !m.roles.some(isSystemRole)
  );
}

export function getUserOrgInfo(user: User | null): UserOrgInfo {
  if (!user) {
    return {
      userId: null,
      platformRole: null,
    };
  }
  const userId = user.itemId;

  // Check ALL memberships for system roles (including excluded orgs like the system admin org)
  const systemAdminMembership = user.memberships?.find(
    (m) => m.organizationId === SYSTEM_ADMIN_ORG_ID
  );
  const sysRole =
    systemAdminMembership && SYSTEM_ADMIN_ORG_ID
      ? (systemAdminMembership.roles.find(isSystemRole) ?? null)
      : null;

  return {
    userId,
    platformRole: sysRole,
  };
}
